/**
 * gtr所有子系统dev配置
 * 仅dev环境使用
 */
/**
 * MICRO_APPS 微应用配置
 * name: string; --- 子系统名跟项目中 package.json 中的name(名称)保持一致,规则 (b|c|d|i|gattaran) + (_|-) + 业务名称 + (_|-) + i18n
 * appLocation: (string|RegExp)[]; --- 项目的入口网关规则，支持正则
 * entry?: string; --- 项目的入口配置（不带 origin） 该字段默认取`appLocation`的第一位，仅支持字符串
 * devEntry?: string; dev环境的子系统入口,默认为http://localhost:8080
 */
export const microApps = [
  {
    name: 'b-manager-merchandise_i18n',
    appLocation: [
      '/manager-merchandish',
      '/manager-merchandish/brand-item',
      '/manager-merchandish/brand-item/list',
    ],
  },

  {
    name: 'b_audit-mgr_i18n',
    appLocation: ['/mcenter'],
  },
  {
    name: 'b_console_i18n',
    appLocation: ['/authmanage'],
  },
  {
    name: 'b_sales-task_i18n',
    appLocation: ['/operateTask', '/task'],
  },
  {
    name: 'b_crm_i18n',
    appLocation: [
      '/bizopp',
      '/leads',
      '/farming',
      '/stores',
      '/process',
      '/visit-next',
      '/addShop',
      '/party',
      '/area',
      '/commision',
      '/photo',
      '/brand',
      /^\/shop\/(?!activity)/,
      '/contract-change',
    ],
  },
  {
    name: 'b_delivery-op_i18n',
    appLocation: [
      '/operations/reward',
      '/ridergrade',
      /^\/rider$/,
      /^\/rider\/(?!valution)/,
      '/supplier',
      '/recommend',
    ],
  },
  {
    name: 'd_label-center_i18n',
    appLocation: ['/tagcenter'],
  },
  {
    name: 'b_supply_i18n',
    appLocation: ['/supply', '/manual', '/radius', '/bcConfig'],
  },
  {
    name: 'b_finance_i18n',
    appLocation: ['/finance', '/invoice', '/riderRfc', '/bank-manage', '/expense-manage'],
  },
  {
    name: 'b_cfg-mgr_i18n',
    appLocation: [
      '/launch-initialization',
      '/consumer',
      '/rider/valution',
      '/businessDistribution',
    ],
  },
  {
    name: 'b_trans-mgr_i18n',
    appLocation: ['/order', '/trip', '/user', '/evaluation'],
  },
  {
    name: 'b_usr-mkt_i18n',
    appLocation: [/^\/operations\/(?!reward)/],
    entry: '/operations/landingPageCombo',
  },
  {
    name: 'b_merchant-op_i18n',
    appLocation: [
      '/platform-item-manage',
      '/brand-item-manage',
      '/shop/activity',
      '/dish',
      '/poseidon',
      '/flowcontrol',
      '/guidance',
      '/service-control',
      '/p-cancel',
      '/scenter',
      '/shopV2',
      '/new-store',
      '/picture-quality',
    ],
  },
  {
    name: 'b_tianji_i18n',
    appLocation: ['/tianji'],
  },
  {
    name: 'b_material_i18n',
    appLocation: ['/inventory'],
  },
]
// 未接入gtr微前端的子系统
export const otherApps = [
  // 投放平台
  {
    name: 'b_feature_i18n',
    appLocation: ['/starlink'],
  },
  // 客服平台项目，主要针对pad，移动端的，暂不需接入 https://pre-gattaran.didi-food.com/customerService/entrega/order/detail?orderId=5764618002251186963&cityId=52210400
  {
    name: 'b_customer-service_i18n',
    appLocation: ['/customerService'],
  },
]
export const prefetchNum = 0

export const ignoreScript = ['watermark.xiaojukeji.com', 'maps.googleapis', 'map_webapp_ibt/mapsdk']

export const jumpErrorPageCode = ['LOADING_SOURCE_CODE', 'SKIP_BECAUSE_BROKEN']
